import React, { useState, useRef, useEffect } from "react"
import { withMicrocopy } from "~contexts/MicrocopyContext"
import iconChevron from "./icon-chevron.svg"
import * as style from "./Collapsible.module.scss"

const Index = ({
  header, children, open = false, id, className = '', headerClassName = '', elementRef = undefined,
}) => {
  const collapsibleRef = elementRef || useRef(null)
  const [isOpen, setIsOpen] = useState(open)
  const toggle = () => setIsOpen(!isOpen)

  useEffect(() => {
    const downHandler = ({ keyCode }) => {
      if (keyCode === 13) {
        const isActive = document.activeElement === collapsibleRef.current
          || document.activeElement?.children?.[0] === collapsibleRef.current
        if (isActive) {
          setIsOpen(!isOpen)
        }
      }
    }

    window.addEventListener('keydown', downHandler)

    return () => {
      window.removeEventListener('keydown', downHandler)
    }
  }, [isOpen, setIsOpen, collapsibleRef])

  return (
    <div ref={collapsibleRef} className={`${className}`} {...(id ? { id } : {})}>
      <div onClick={toggle} className={`${style.title} ${headerClassName}`}>
        <img
          alt="chevron"
          src={iconChevron}
          className={`${style.icon} ${isOpen ? style.open : ''}`}
        />
        {header}
      </div>
      {isOpen && <>{children}</>}
    </div>
  )
}
export default withMicrocopy(Index)
